<template>
  <BlockTemplate expandable="opened">
    <template #header>
      <BlockHeader
        ref="header"
        class="header"
        :likable="false"
        :checkable="false"
      >
        <Icon name="wip" size="4rem" class="icon" />
        <span>
          {{ $t('contentNotAvailable.title') }}
        </span>
      </BlockHeader>
    </template>
    <div class="content">
      <p>
        {{ $t('contentNotAvailable.description') }}
      </p>
      <StoresMobileApps :show-delay="200" />
    </div>
  </BlockTemplate>
</template>
<script lang="ts" setup></script>
<style lang="scss" scoped>
.icon {
  margin-right: 1rem;
}
.content {
  display: flex;
  flex-direction: column;
  gap: var(--gap_l);
}
</style>
